<template>
  <div>
      <!--<nav-tit :dataTit="eView.title"></nav-tit>-->
      <!--<def-hn></def-hn>-->
      <div class="banner-all" :style="'height: ' + eView.banner_height + 'px'">
          <mt-swipe :auto="4000">
              <mt-swipe-item v-for="(item, index) in eView.banner" :key="index">
                  <img @click="goUrl(item)" :src="item.src" class="banner-img"/>
              </mt-swipe-item>
          </mt-swipe>
          <div class="view-num" v-if="eView.view_show === 1">浏览量：{{eView.view}}</div>
      </div>
      <notice-bar :message="eView.notice"></notice-bar>
      <div :style="'background-image: url(' + eView.bgimg + ');min-height:' + (screenHeight - 250 - 26) + 'px'" class="all-cont">
          <ul class="plate-ul">
              <!--height: ' + item.height-->
              <li :style="'width: ' + item.width + '%'" class="plate-li" v-for="(item, index) in eView.plates" :key="index">
                  <!--height: ' + (item.height <= 0 ? 'auto' : item.height + 'px')-->
                  <div @click="goLi(item)" :style="'height: '+ (item.height <= 0 ? 'auto' : item.height + 'px') + ';padding: 10px 0;border-radius: 10px;width: 100%;background-color: ' + item.bg_color + ';background-image: url(' + item.bg_img + ');background-repeat: no-repeat;background-size: 100% 100%;'">
                      <div class="plate-li-cont">
                          <div class="msg">
                              <div class="msg-name">{{item.cname === '返回直播间' ? '': item.cname}}</div>
                              <img class="msg-icon" :src="item.icon"/>
                          </div>
                          <div class="e-name">{{item.ename}}</div>
                      </div>
                  </div>
              </li>
          </ul>
          <div class="tips-bottom">
              <div @click="goU">Powered by 新医讯</div>
              <div>
                  <span @click="goU1">课程存档</span>  <span @click="goU">课程内容版权均归授课专家及其单位所有</span></div>
              <div @click="goU2">渝ICP备20001772号-1   <img src="../../assets/def.png"/> 渝公网安备 50010702502773号</div>
          </div>
      </div>
  </div>
</template>

<script>

import { Toast } from 'mint-ui'
import NavTit from "../public/navTit"
import DefHn from "../public/defHn"
import NoticeBar from "../public/noticeBar";
import config from '../../common/config.js'
import store from '../../store'
let wx = require('weixin-js-sdk')


export default {
  components: {
    NoticeBar,
    NavTit, DefHn},
  name: 'index',
  store: store,
  data () {
    return {
      eView: {
      },
      screenHeight: ''
    }
  },
  mounted () {
    // WeixinJSBridge.call('showOptionMenu');
    this.screenHeight = window.screen.height
    this.getView()
  },
  watch: {
    $route () {
      this.getView()
    }
  },
  methods: {
    goUrl (i) {
      if (i.link !== '') {
        window.open(i.link)
      }
    },
    goU () {
      window.open('http://www.xyxun.top/')
    },
    goU1 () {
      window.open('http://www.xyxun.top/archive/course')
    },
    goU2 () {
      window.open('http://www.beian.miit.gov.cn/')
    },
    getView () {
      let that = this
      this.$g.ajax({
        method: 'post',
        path: 'events/view',
        data: {
          id: this.$route.query.id
        },
        cbSuccess(data) {
          if(data.memo.enabled === 0){
            that.$router.push({path: '/end'})
            return false
          }
          that.eView = data.memo
          document.title = data.memo.title
          sessionStorage.setItem('activityView', JSON.stringify(data.memo))
          that.goyanzheng()
        },
        cbError(data) {
          let msg = data.msg
          Toast({
            message: msg,
            position: 'bottom',
            duration: 1000
          })
        }
      })
    },
    goLi (i) {
      if (i.typ === 'link' && i.link) {
        window.open(i.link)
        return false
      }
      if (i.typ === 'photo') {
        if (this.isIOS() && !this.isSafari()) {
            this.$router.push('/users/authlogin/' + store().getters.auth('jwt') + '/' + this.$route.query.id + '/1')
        } else {
          this.$router.push('/' + i.typ + '/index?eid=' + this.$route.query.id + '&fid=0')
        }
      } else {
        this.$router.push('/' + i.typ + '/index?eid=' + this.$route.query.id)
      }
    },
    // 是否ios
    isIOS () {
      let u = navigator.userAgent
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    },
    // 是否Safari
    isSafari () {
      let agent = navigator.userAgent.toLowerCase()
      return agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0
    },
    goyanzheng () {
      let that = this
      this.$g.ajax({
        path: 'uploaders/jssdksign',
        method: 'post',
        data: {
          url: location.href.split('#')[0]
        },
        cbSuccess (data) {
          that.begin(data.memo.nonceStr, data.memo.signature, data.memo.timestamp)
        },
        cbError (error) {
          let msg = error.msg
          Toast({
            message: msg,
            position: 'bottom',
            duration: 1500
          })
        }
      })
    },
    begin (nonceStr, signature, timestamp) {
      let that = this
      let activityView = JSON.parse(sessionStorage.getItem('activityView'))
      let shareWxLink = config.host + '?id=' + activityView.id
      wx.config({
        debug: false,
        appId: 'wx97dae6033b09528a',
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage']
      })
      wx.ready(function () {
        wx.updateAppMessageShareData({
          title: activityView.title, // 分享标题
          desc: activityView.share_text !== null ? activityView.share_text : activityView.title, // 分享描述
          link: shareWxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: activityView.banner.length > 0 ? activityView.banner[0].src : '' , // 分享图标
          success: function () {
            // that.$emit('shareok')
            // 设置成功
            //   alert('分享给朋友,分享到QQ,设置成功')
          }
        })
        wx.updateTimelineShareData({
          title: activityView.title, // 分享标题
          link: shareWxLink,// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: activityView.banner.length > 0 ? activityView.banner[0].src : '' , // 分享图标
          success: function () {
            // 设置成功
            // alert('分享到朋友圈,分享到QQ空间,设置成功')
          }
        })
      })
      wx.onMenuShareTimeline({
        title: activityView.title, // 分享标题
        link: shareWxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: activityView.banner.length > 0 ? activityView.banner[0].src : '' , // 分享图标
        success: function () {
          // 用户点击了分享后执行的回调函数
        }
      })
      wx.onMenuShareAppMessage({
        title: activityView.title, // 分享标题
        desc: activityView.share_text !== null ? activityView.share_text : activityView.title, // 分享描述
        link: shareWxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: activityView.banner.length > 0 ? activityView.banner[0].src : '' ,
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户点击了分享后执行的回调函数
        }
      })
      wx.error(function (res) {
        console.log(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .banner-all{
    height: 250px;
    position: relative;
    /*background: #00a4a0;*/
  }
  .banner-img{
    width: 100%;
    height: 100%;
  }
  .view-num{
      position: absolute;
      top: 10px;
      color: #fff;
      z-index: 2;
      right: 10px;
      font-size: 13px;
  }
  .all-cont{
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding-top: 10px;
      background-color: #f7f7f7;
  }
  .plate-ul{
      display: flex;
      flex-wrap: wrap;
      color: #FFFFFF;
      justify-content: center;
      .plate-li{
          background-repeat: no-repeat;
          background-size: 100% 100%;
          /*margin-left: 6px;*/
          /*margin-right: 6px;*/
          /*margin-bottom: 6px;*/
          display: flex;
          align-items: center;
          padding: 10px 6px 0 6px;
          box-sizing: border-box;
          .plate-li-cont{
              width: 80%;
              justify-content: center;
              margin: 0 auto;
              .msg{
                  display: flex;
                  justify-content: space-between;
                  .msg-name{
                      font-size: 16px;
                  }
                  .msg-icon{
                      /*float: right;*/
                      /*min-width: 20px;*/
                      /*min-height: 20px;*/
                  }
              }
              .e-name{
                  font-size: 13px;
              }
          }
      }
  }
    .tips-bottom{
        margin-top: 50px;
        font-size: 12px;
        color: #5a5a5a;
        text-align: center;
        line-height: 20px;
        img{
            position: relative;
            top: 4px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue